import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

type UnsavedChangesState = Record<string, boolean>;

const initialState: UnsavedChangesState = {};

const UnsavedChangesSlice = createSlice({
    name: "UnsavedChangesSlice",
    initialState,
    reducers: {
        setUnsavedChanges: (state, action: PayloadAction<{ key: string; value: boolean }>) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        clearAllUnsavedChanges: () => {
            return {};
        },
        //not in use currently
        clearUnsavedChange: (state, action) => {
            delete state[action.payload];
        },
    },
});

export const { setUnsavedChanges, clearAllUnsavedChanges, clearUnsavedChange } = UnsavedChangesSlice.actions;
export default UnsavedChangesSlice.reducer;

export const selectHasUnsavedChanges = (state: RootState) =>
    Object.values(state.unsavedChangesSlice).some(Boolean);